export default __webpack_public_path__ + "static/media/project.5f77bf6e.svg";